const { useParams } = require("next/navigation");
const { GET_PRODUCT_APPLICATION, PRODUCT_HANDLER } = require("../constants");
const { useGetApplicationQuery } = require("../redux");
const { useMemo } = require("react");

export const useApplication = (args, options) => {
  const params = useParams();
  const product = params?.product || "";

  const queryObject = useGetApplicationQuery(args ?? "", options);

  const productApplication = useMemo(
    () =>
      GET_PRODUCT_APPLICATION(
        PRODUCT_HANDLER[product],
        queryObject?.data?.data
      ),
    [product, queryObject?.data?.data]
  );

  return {
    ...queryObject,
    productApplication,
  };
};
